import styled from 'styled-components';

export const Cart = styled.div`
  &:hover {
    box-shadow: ${props => props.shadowColor};
  }
`;
